import { useTranslation } from "react-i18next";
import { DocumentDetailsPage } from "components/common/DocumentDetailsPage";
import { findState, quantityValidateSchema } from "components/common/DocumentDetailsPage/utils";
import { initalizeStepsData } from 'components/common/StepsContentGrid';
import StepsItem from "components/common/StepsItem/StepsItem";
import StepsItemView from "components/common/StepsItemView";
import React, { useEffect, useState } from "react";
import { RouteComponentProps, useHistory, useParams } from "react-router";
import { getDocument, uploadDocument } from "services/users";

// const assets = ["BTC", "ETH", "USDT", "ADA", "XLM", "XRP", "BAT", "CHZ"];

type RouteParams = {
    id: string;
};

const config = [
    'Total',
    'Price',
    'Quantity',
    'Currency Type',
    'Type',
    'Approval Date',
    'Step'
];

type IActionErrorHandler = (errors: any) => void;

// const DepositDetails: React.FC<InputProps> = ({ userData, depositId }) => {
const IndexUpdateDetails: React.FC<RouteComponentProps> = () => {
    const { t } = useTranslation();
    const { id } = useParams<RouteParams>();

    const [documentData, setDocumentData] = useState<any>(null);
    const [data, setData] = useState<any>([]);
    const [processing, setProcessing] = useState(false);

    let renderKey = 1;
    // let sysIndexDt: any = null;
    // const { user,token } = useSelector(

    //     (state: any) => state.authReducer
    // )

    const processDocument = (doc: any) => {
        //console.log(doc);
        setDocumentData(doc);
        const data: any = initalizeStepsData("SELL", ["", ""]);
        data[0].text = t("sell_coins_string").toUpperCase();
        data[1].text = t("buy_coins_string").toUpperCase();
        data[0].status = "passed";
        data[1].status = "passed";
        const coins: any = {};

        const setSellCoins = () => {
            let i = 1;
            // let savedCount = 0;
            const date = doc.dt;

            doc.meta.coins.forEach((coin: any) => {
                // console.log(coin);
                //const savedCoin = savedCoins ? savedCoins.find((c: any) => c.coin == coin.coin) : undefined;
                // if (savedCoin) ++savedCount;
                //const sold=doc.meta?.coins?doc.meta?.coins.find((c:any)=>c.coin==coin.coin):null;
                let quantity = coin.usdtVolume ? coin.usdtVolume : "";
                let price = coin.price ? coin.price : "";
                const row: any = {
                    id: "SELL" + coin.coin + renderKey,
                    step: null,
                    status: "passed",
                    approval_date: date || "-",
                    type: t("sell_coins_string").toUpperCase(),
                    text: coin.coin + " ⇄ USD",
                    currency_type: t("crypto_string"),
                    currency: coin.coin,
                    quantity: quantity,
                    quantityDecimals: 8,
                    price: price,
                    priceDecimals: 8,
                    total: coin.cryptoVolume,
                    totalDecimals: 8,
                    editable: { },
                    quantityMask: 'cryptoprice',
                    priceModifier: -1,
                };
                data.splice(i++, 0, row);
                coins[coin.coin] = row;
            });
            // if (savedCount == doc.meta?.coins?.length) {
            //     data[0].actions = {
            //         approve: {
            //             title: "Approve",
            //             action: () => {
            //                 saveCoin(null, "approved").then(sleep).then(res => {
            //                     reloadDocument();
            //                 }).finally(() => setProcessing(false));
            //             }
            //         }
            //     };
            // }
            const setBuyCoins = (coins: any[]) => {
                // console.log("SAVED",savedCoins);
                const date = doc.dt;
                coins.forEach((coin: any) => {
                    let quantity = coin.cryptoVolume ? coin.cryptoVolume : "";
                    let price = coin.price ? coin.price : "";

                    data.push({
                        id: "BUY" + coin.coin + renderKey,
                        step: null,
                        status:"passed",
                        approval_date: date || "-",
                        type: t("buy_coins_string").toUpperCase(),
                        text: "USD ⇄ " + coin.coin,
                        currency_type: t("crypto_string"),
                        currency: "USD",
                        quantity: quantity,
                        quantityDecimals: 8,
                        quantityMask: "cryptoprice",
                        price: price,
                        priceDecimals: 8,
                        total: coin.usdtVolume,
                        totalDecimals: 8,
                        priceModifier: 1,
                        editable: { },
                    });
                });
                setData(data);
            };
            // const loadBuyCoins = (sellCoins: any[]) => {
            //     if (doc.meta?.modRefs?.CRYPTO_BUY) {
            //         getDocument(doc.meta?.modRefs?.CRYPTO_BUY).then(res => {
            //             // console.log("CRYPTO BUY", res);
            //             sysIndexDt = res?.meta?.sysIndexDt;
            //             setBuyCoins(sellCoins, res?.meta?.coins);
            //         })
            //     }
            //     else {
            //         setBuyCoins(sellCoins);
            //     }
            // }

            // if (doc.meta.buy_coins) {
            //     loadBuyCoins(doc.meta.buy_coins);
            // }
            // else {

            setBuyCoins(doc.meta?.buy_coins);
            // }
        };
        setSellCoins();
        // if (doc.meta?.modRefs?.CRYPTO_SELL) {
        //     getDocument(doc.meta?.modRefs?.CRYPTO_SELL).then(res => {
        //         setSellCoins(res?.meta?.coins);
        //     })
        // }
        // else {
        //     setSellCoins();
        // }
    };

    const reloadDocument = (callback?: (doc: any) => void) => {
        getDocument(id).then((doc: any) => {
            // console.log(doc);
            processDocument(doc);
            if (typeof callback == "function") {
                callback(doc);
            }
        });
    };

    useEffect(() => {
        reloadDocument();
        //
    }, [id]);
    // }, [userData, depositId]);

console.log(data);

    return (
        <DocumentDetailsPage
            title={t("index_update_details_string")}
            columns={config}
            documentData={documentData}
            // accountId={withdrawalData.accountId}
            //bankDetailsData={bankDetailsData}
            stepsData={data}
/*             BAMCId={BAMCId}
            BAMCStatus={BAMCStatus}
            BAMCStatusClass={BAMCStatusClass}
*/            processing={processing}
            itemComponent={StepsItemView}
/*             onViewBAMC={() => {
                setViewBAMC(true);
                //@ts-ignore
                document.getElementById("view-document-btn").click();
            }}
 */        >
        </DocumentDetailsPage>
    )
};

export default IndexUpdateDetails;